import type {EntityFieldItemApplier} from '@github-ui/optimistic-connection'

export const applyIssueFieldValue: EntityFieldItemApplier = (entity, operation) => {
  if (operation.field !== 'issueFieldValues') return
  const issueFieldValues = entity.issueFieldValues
  if (!issueFieldValues || typeof issueFieldValues !== 'object' || Array.isArray(issueFieldValues)) return

  const nodes = (issueFieldValues as {nodes?: unknown}).nodes
  if (!Array.isArray(nodes)) return

  const nodeIndex = nodes.findIndex(node => {
    if (!node || typeof node !== 'object' || Array.isArray(node)) return false
    const field = (node as {field?: unknown}).field
    return field && typeof field === 'object' && !Array.isArray(field) && (field as {id?: unknown}).id === operation.key
  })

  if (operation.type === 'removeEntityFieldItem') {
    if (nodeIndex !== -1) nodes.splice(nodeIndex, 1)
    return
  }

  const nextNode = structuredClone(operation.item)
  if (nodeIndex === -1) nodes.push(nextNode)
  else nodes[nodeIndex] = nextNode
}
